import queryString from 'query-string';

export default function makeQueryString(to, params) {
    return `/${to}?${queryString.stringify(params)}`;
}



/** WEBPACK FOOTER **
 ** ./src/utils/makeQueryString.js
 **/